declare global {
  interface Window {
    __dev__: boolean;
  }
}

window.__dev__ = !!process.env.REACT_APP_ENV;

export default global;
